// extracted by mini-css-extract-plugin
module.exports = {"container":"NavBar_container__1jYE_","name":"NavBar_name__AIih-","burger":"NavBar_burger__2mEW8","burgerBtn":"NavBar_burgerBtn__hBFsj","nav_list":"NavBar_nav_list__1sm2M"};